import { createSelector } from 'reselect';
import _ from 'lodash';

const getMailClassNodes = state => state.productSelector.mailClassNodes;
const getCategories = state => state.productSelector.categories;

export const getIsShowOnlySelectedMailClasses = state => state.productSelector.isShowOnlySelected;

export const getMailClassesIsLoading = state => state.productSelector.isLoading;

export const getExpanded = (
  state,
  props,
) => state.productSelector.categories[props.mailCategory].expanded;

export const getSelected = (
  state,
  props,
) => state.productSelector.categories[props.mailCategory].selected;

export const getCheckedMailClasses = state =>
  Object.keys(state.productSelector.categories)
    .map(key => state.productSelector.categories[key].selected)
    .reduce((a, b) => a.concat(b), []);

export const makeGetVisibleMailClassNodes = () => createSelector(
  [
    getMailClassNodes,
    getIsShowOnlySelectedMailClasses,
    getSelected,
  ],
  (mailClassNodes, isShowOnlySelected, selected) => {
    if (isShowOnlySelected) {
      return mailClassNodes.map(mailClassNode => ({
        ...mailClassNode,
        children: mailClassNode.children.filter(child => selected.includes(child.value)),
      })).filter(mailClassNode => mailClassNode.children && mailClassNode.children.length > 0);
    }

    return mailClassNodes;
  },
);

export const getAllSubClassCodes = createSelector(
  [productSelectorState => productSelectorState.mailClassNodes],
  mailClassNodes => _.flatten([
    ...mailClassNodes.map(mailClassNode => (mailClassNode.children.map(child => (child.value)))),
  ]),
);

export const getAllSelectedSubClassesByCategory = createSelector(
  [getCategories],
  categories => Object.keys(categories)
    .map(categoryCode => ({
      mailCategoryCode: categoryCode,
      mailSubClasses: categories[categoryCode].selected,
    })),
);

export const getSelectedProducts = createSelector(
  [getCategories],
  categories => Object.keys(categories)
    .map(categoryCode => (categories[categoryCode].selected.length > 0 ? categoryCode : undefined))
    .filter(element => element),
);
